import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { SponsoredAdEntity, StatsEntity } from '@core/entities';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  getStats(userId: number): Observable<StatsEntity> {
    return this._http.get<any>(`${this._apiUrl}/numberOfPostEventsMessage/user/${userId}`).pipe(map((response) => response.result));
  }

  getDesktopSponsoredAds(): Observable<SponsoredAdEntity[]> {
    return this._http.get<any>(`${this._apiUrl}/getBannerForDashboard_Desktop`).pipe(map((response) => response.result.banner));
  }

  getMobileSponsoredAds(): Observable<SponsoredAdEntity[]> {
    return this._http.get<any>(`${this._apiUrl}/getBannerForDashboardMobileApp`).pipe(map((response) => response.result.banner));
  }

  updateBannerStats(data: any): Observable<any> {
    return this._http.post<any>(`${this._apiUrl}/bannerClick`, data);
  }
}
